module.exports = __webpack_public_path__ + "static/media/search--red.1cb06a70.svg";